import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center gap-2 text-center" };
const _hoisted_2 = { class: "text-xl font-bold text-(--text-text-black-default) leading-6" };
const _hoisted_3 = { class: "text-base text-(--text-text-body) leading-6" };
const _hoisted_4 = {
    key: 0,
    class: "text-sm text-(--text-text-danger-default)",
    role: "alert"
};
import { Button, Modal } from "@eudonet/opal";
import { computed, nextTick, ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactDeleteAddressModal',
    props: {
        modelValue: { type: Boolean },
        address: {}
    },
    emits: ["update:modelValue", "confirm"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        // Inherited address = linked to an organisation; deleting it only removes the
        // contact↔organisation link, leaving the organisation's address untouched.
        const bodyMessageKey = computed(() => {
            if (props.address.isPrimary) {
                return "contact.detail.addresses.deleteModal.primaryWarning";
            }
            if (props.address.source === "Linked") {
                return "contact.detail.addresses.deleteModal.inheritedInfo";
            }
            return "contact.detail.addresses.deleteModal.subtitle";
        });
        const emit = __emit;
        const isDeleting = ref(false);
        const errorMessage = ref(null);
        const confirmButtonRef = ref(null);
        function onClose() {
            if (isDeleting.value)
                return;
            errorMessage.value = null;
            emit("update:modelValue", false);
        }
        function onConfirm() {
            emit("confirm");
        }
        watch(() => props.modelValue, async (visible) => {
            if (visible) {
                errorMessage.value = null;
                isDeleting.value = false;
                await nextTick();
                confirmButtonRef.value?.$el?.focus();
            }
        });
        __expose({
            setDeleting(value) {
                isDeleting.value = value;
            },
            setError(message) {
                errorMessage.value = message;
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": __props.modelValue,
                size: "xs",
                "show-close-button": true,
                "show-header": false,
                dismissable: false,
                "close-on-escape": true,
                "footer-position": "center",
                "onUpdate:modelValue": onClose
            }, {
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        size: "md",
                        label: _ctx.$t('contact.detail.addresses.deleteModal.cancelLabel'),
                        disabled: isDeleting.value,
                        onClick: onClose
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        ref_key: "confirmButtonRef",
                        ref: confirmButtonRef,
                        variant: "error",
                        size: "md",
                        label: _ctx.$t('contact.detail.addresses.deleteModal.confirmLabel'),
                        "icon-left": "ri-delete-bin-6-line",
                        disabled: isDeleting.value || __props.address.isPrimary,
                        onClick: onConfirm
                    }, null, 8 /* PROPS */, ["label", "disabled"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center justify-center w-12 h-12 rounded-lg border border-(--border-border-base-soft) bg-white" }, [
                            _createElementVNode("i", {
                                class: "ri-delete-bin-6-line text-2xl text-(--text-text-black-default)",
                                "aria-hidden": "true"
                            })
                        ], -1 /* CACHED */)),
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("contact.detail.addresses.deleteModal.title")), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(bodyMessageKey.value)), 1 /* TEXT */),
                        (errorMessage.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value"]));
        };
    }
});
